<template>
  <div>
    <app-spinner v-if="!page_loaded" />
    <template v-else>
      <v-client-table
        :data="table.items"
        :columns="table.columns"
        :options="table.options"
        class="table-default"
      >
        <template #h__status><div class="table-default__left">Status</div></template>
        <template #h__tax><div class="table-default__left">Tax</div></template>
        <template #status="{ row }">
          <div class="table-default__left">
            <span class="status-tag" :style="{backgroundColor: row.status.color}">
              {{ row.status.name }}
            </span>
          </div>
        </template>
        <template #tax="{ row }">
          <div class="table-default__left table-default__controls">
            <div
              v-tooltip="{ content: row.notes, placement: 'top-start', offset: 10 }"
              class="table-default__activity table-default__activity--notes"
              :class="{'table-default__activity--active': row.notes}"
            />
            <router-link :to="{name: 'finance-taxes-detail', params: {id: row.id }}" class="table-default__link-border">
              {{ row.tax.name_expense }} ({{ dateFormatMonth(row.accounting_date) }})
            </router-link>
          </div>
        </template>
        <template #date="{ row }">{{ dateFormat(row.date) }}</template>
        <template #amount="{ row }">{{ amountFormat(row.amount) }}</template>
        <template #attachment="{ row }">
          <a
            :class="{'table-default__disabled': !row.attachment}"
            :href="row.attachment?.file"
            target="_blank"
          >
            <img alt="Attachment" src="@/assets/img/snacks-link.svg">
          </a>
        </template>
      </v-client-table>
    </template>
  </div>
</template>

<script>
import { getFinanceTaxesList } from '@/http'
import { format, parse } from 'date-fns'

export default {
  name: 'EmployeesPayrollTaxes',
  data() {
    return {
      page_loaded: false,
      table: {
        items: [],
        columns: ['status', 'tax', 'date', 'amount', 'attachment'],
        options: {
          headings: {
            'status': 'Status',
            'tax': 'Tax',
            'date': 'Date',
            'amount': 'Amount',
            'attachment': 'Attachment',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 1000,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
    }
  },
  created() {
    getFinanceTaxesList({ payroll: this.$route.params.id })
      .then(response => {
        this.table.items = response.data
        this.page_loaded = true
      })
  },
  methods: {
    dateFormat(date) {
      return date ? format(parse(date, 'yyyy-MM-dd', new Date()), 'dd MMM yyyy') : '-'
    },
    dateFormatMonth(date) {
      return date ? format(parse(date, 'yyyy-MM-dd', new Date()), 'MMM yyyy') : '-'
    },
    amountFormat(amount) {
      return amount ? new Intl.NumberFormat('ru-RU').format(amount) : '-'
    },
  }
}
</script>
